import React from 'react';
import {FormHelperText, Slider} from '@mui/material';
import FormControl from '@mui/material/FormControl';
import {useAutoForm} from '../AutoForm/useAutoForm';
import {UPDATES} from '../../shared/UPDATES';
import {AtrFormValues} from './AtrFields';

const SCORES = [
  {
    value: 1,
    label: '1',
  },
  {
    value: 2,
    label: '2',
  },
  {
    value: 3,
    label: '3',
  },
  {
    value: 4,
    label: '4',
  },
  {
    value: 5,
    label: '5',
  },
];

const ScoreSlider = () => {
  const {errors, values, setFieldValue} = useAutoForm<AtrFormValues>();
  return (
    <FormControl fullWidth>
      <Slider
        data-testid="score-slider"
        min={1}
        max={5}
        value={values.amendedValue ?? undefined} // Was there as reason this was defaultValue over value?
        getAriaValueText={(value) => `${value}`}
        aria-label="Score"
        step={null}
        valueLabelDisplay="auto"
        marks={SCORES}
        onChangeCommitted={(e, value) =>
          setFieldValue(UPDATES._1701, 'amendedValue', value)
        }
      />
      {errors?.amendedValue && <FormHelperText>{errors.amendedValue}</FormHelperText>}
    </FormControl>
  );
};

export default ScoreSlider;
